import Layout from './components/layout/Layout.jsx';

import {fetchSeatingplan, selectSeatingplan,} from './redux/seatingplanReducer';
import {fetchEventIfNeeded, selectEvent} from './redux/eventReducer';
import {fetchVenueIfNeeded} from './redux/venueReducer';
import {
    clearShoppingCartIfNecessary,
    createShoppingCartIfNeeded,
    updateSelectedAndSelectableSeats,
} from './redux/shoppingCartReducer';
import {fetchBookingOfficeIfNeeded} from './redux/bookingOfficeReducer';
import {syncVolatileAvailability} from './redux/eventPageReducer';
import {fetchSeatState} from './redux/seatStateReducer';
import {fetchSponsorReservationsState, loadSponsorCodesConfig, reset} from './redux/sponsorCodeReducer';
import {fetchMetaDataIfNeeded} from './redux/fileReducer';
import {loadAccessCodesConfig} from './redux/accessCodesReducer';
import {setThemeConfigForShipmentAddress} from './redux/customerReducer';


import EventPage from './pages/event/EventPage.jsx';
import EventPageSeatingplan from './pages/event-seatingplan-entry/EventPageSeatingplan';
import SeatingplanDisplayPage from './pages/seatingplan-display/SeatingplanDisplayPage.jsx';
import {
    checkoutChangeSelectedPaymentType,
    determineDefaultOrSelectedAvailableShipmentType,
} from './redux/checkoutPageReducer';
import EventErrorPage from './pages/event-error/EventErrorPage.jsx';
import ShoppingCartErrorPage from './pages/shoppingcart-error/ShoppingCartErrorPage.jsx';
import ShoppingCartExpiredPage from './pages/shoppingcart-error/ShoppingCartExpiredPage.jsx';
import OrderErrorPage from './pages/order-error/OrderErrorPage.jsx';
import ShoppingCartCheckoutPage from './pages/shopping-cart-checkout/ShoppingCartCheckoutPage.jsx';
import UnknownErrorPage from './pages/UnknownErrorPage.jsx';
import WebshopOccupiedInfoPage from './pages/WebshopOccupiedInfoPage.jsx';
import CheckoutDispatcherPage from "./pages/checkout_process/CheckoutDispatcherPage";
import CheckoutError from "./pages/checkout_process/CheckoutError";
import ErrorPage from "./pages/ErrorPage.jsx";
import sponsorCodeService from "./lib/sponsorCodes-service.js";
import theme from "./components/theme/Theme.jsx";
import PartnershopErrorPage from "./pages/PartnershopErrorPage.jsx";
import NotFoundPage from "./pages/NotFoundPage.jsx";

const uuidRegExp = '\\w{8}-\\w{4}-\\w{4}-\\w{4}-\\w{12}';
const uuidRegExpPattern = new RegExp(`^${uuidRegExp}$`);

const skipRouteIfInvalidUuid = (context, name, isOptional = false) => {
	const value = context.params[name];
	if (isOptional && value === undefined) return;
	if (!uuidRegExpPattern.test(value)) return context.next();
};

const withUuid = (context, name, callback, isOptional = false) => {
	const routingResult = skipRouteIfInvalidUuid(context, name, isOptional);
	if (routingResult) return routingResult;

	return callback(context.params[name]);
};

const routes = [
	{
		path: '{/*any}/event-error',
		action: () => ({
			component: (<Layout content={<EventErrorPage />} />),
			fetchData: [],
		}),
	},
	{
		path: '{/:eventUuid}/shoppingcart-error',
		action: (context) => withUuid(context, 'eventUuid', (eventUuid) => ({
			component: (<Layout content={<ShoppingCartErrorPage eventUuid={eventUuid} />} />),
			fetchData: [],
		}), true),
	},
	{
		path: '{/:eventUuid}/shoppingcart-expired',
		action: (context) => withUuid(context, 'eventUuid', (eventUuid) => ({
			component: (<Layout content={<ShoppingCartExpiredPage eventUuid={eventUuid} />} />),
			fetchData: [],
		}), true),
	},
	{
		path: '{/:eventUuid}/order-error',
		action: (context) => withUuid(context, 'eventUuid', (eventUuid) => ({
			component: (<Layout content={<OrderErrorPage eventUuid={eventUuid} />} />),
			fetchData: [],
		}), true),
	},
	{
		path: '{/:eventUuid}/unknown-error',
		action: (context) => withUuid(context, 'eventUuid', (eventUuid) => ({
			component: (<Layout content={<UnknownErrorPage eventUuid={eventUuid} />} />),
			fetchData: [],
		}), true),
	},
	{
		path: '{/:eventUuid}/not-found',
		action: (context) => withUuid(context, 'eventUuid', (eventUuid) => ({
			component: (<Layout content={<NotFoundPage eventUuid={eventUuid} />} />),
			fetchData: [],
			pageTitle: 'Seite nicht gefunden',
		}), true),
	},
	{
		path: '/sp/:eventUuid/shoppingcart',
		action: (context) => withUuid(context, 'eventUuid', (eventUuid) => ({
			component: (<Layout content={<ShoppingCartCheckoutPage />} />),
			fetchData: [
				() => async (dispatch, getState) => {
					await dispatch(fetchBookingOfficeIfNeeded());
					await dispatch(createShoppingCartIfNeeded());
					const defaultPaymentType = getState().bookingOffice.defaultPaymentType;
					await dispatch(checkoutChangeSelectedPaymentType(defaultPaymentType));},
				() => async (dispatch) => {
					await dispatch(fetchEventIfNeeded(eventUuid));
					await dispatch(setThemeConfigForShipmentAddress());
				},
				() => selectEvent(eventUuid),
			],
			clientOnly: [
				() => async(dispatch) => {
					dispatch(determineDefaultOrSelectedAvailableShipmentType());
				},
			],
			pageTitle: 'Tickets kaufen - Warenkorb',
		})),
	},
	{
		path: '/fs/:eventUuid/shoppingcart',
		action: (context) => withUuid(context, 'eventUuid', (eventUuid) => ({
			component: (<Layout content={<ShoppingCartCheckoutPage />} />),
			fetchData: [
				() => async (dispatch, getState) => {
					await dispatch(fetchBookingOfficeIfNeeded());
					await dispatch(createShoppingCartIfNeeded());
					const defaultPaymentType = getState().bookingOffice.defaultPaymentType;
					await dispatch(checkoutChangeSelectedPaymentType(defaultPaymentType));
				},
				() => async (dispatch) => {
					await dispatch(fetchEventIfNeeded(eventUuid));
					await dispatch(setThemeConfigForShipmentAddress());
				},
				() => selectEvent(eventUuid),
			],
			clientOnly: [
				() => async(dispatch) => {

					dispatch(determineDefaultOrSelectedAvailableShipmentType());
				},
			],
			pageTitle: 'Tickets kaufen - Warenkorb',
		})),
	},
	{
		path: '/shoppingcart',
		action: () => ({
			component: (<Layout content={<ShoppingCartCheckoutPage />} />),
			fetchData: [
				() => async (dispatch, getState) => {
					await dispatch(fetchBookingOfficeIfNeeded());
					await dispatch(createShoppingCartIfNeeded());
					const defaultPaymentType = getState().bookingOffice.defaultPaymentType;
					await dispatch(checkoutChangeSelectedPaymentType(defaultPaymentType));
					await dispatch(setThemeConfigForShipmentAddress());
				},
			],
			clientOnly: [
				() => async(dispatch) => {
					dispatch(determineDefaultOrSelectedAvailableShipmentType());
				},
			],
			pageTitle: 'Tickets kaufen - Warenkorb',
		}),
	},
	/*{
		path: `/:eventUuid(${uuidRegExp})?/payment-error`,
		action: (ctx) => ({
			component: (<Layout content={<PaymentErrorPage eventUuid={ctx.params.eventUuid} />} />),
			fetchData: [],
		}),
	},*/
	{
		path: '/:uuid/checkout',
		action: (context) => withUuid(context, 'uuid', (uuid) => ({
			component: (<Layout content={<CheckoutDispatcherPage />} />),
			fetchData: [
				() => async (dispatch) => {
					await dispatch(fetchBookingOfficeIfNeeded());
					await dispatch(createShoppingCartIfNeeded());
				},
				() => async (dispatch, getState) => {
					await dispatch(fetchEventIfNeeded(uuid));
					const event = getState().event.elements[uuid];
					if (event && event.imagesMetadataIds && event.imagesMetadataIds.length > 0) {
						await dispatch(fetchMetaDataIfNeeded(event.imagesMetadataIds[0]));
					}
					const venueId = (getState().event.elements[uuid] || {}).venueId;
					return dispatch(fetchVenueIfNeeded(venueId));
				},
				() => selectEvent(uuid),
			],
			clientOnly: [
				() => async(dispatch) => {
					dispatch(determineDefaultOrSelectedAvailableShipmentType());
				},
			],
			pageTitle: 'Tickets kaufen',
			checkoutProcess: true,
		})),
	},

	{
		path: `/checkout`,
		action: () => ({
			component: (<Layout content={<CheckoutDispatcherPage />} />),
			fetchData: [
				() => async (dispatch) => {
					await dispatch(fetchBookingOfficeIfNeeded());
					await dispatch(createShoppingCartIfNeeded());
				},
			],
			clientOnly: [
				() => async(dispatch) => {
					dispatch(determineDefaultOrSelectedAvailableShipmentType());
				},
			],
			pageTitle: 'Tickets kaufen',
			checkoutProcess: true,
		}),
	},
	{
		path: '{/*any}/checkout-error',
		action: () => ({
			component: (<Layout content={<CheckoutError />} />),
			fetchData: [],
		}),
	},

	{
		path: '/:uuid',
		action: (context) => withUuid(context, 'uuid', (uuid) => ({
			fetchData: [
				() => async (dispatch) => {
					await dispatch(fetchEventIfNeeded(uuid));
				},
			],
			saleRedirectEventUuid: uuid,
		})),
	},

	{
		path: '/sp/:uuid',
		action: (context) => withUuid(context, 'uuid', (uuid) => ({
			component: (<Layout content={<EventPageSeatingplan />} />),
			fetchData: [
				() => async (dispatch, getState) => {
					await dispatch(fetchBookingOfficeIfNeeded());
					await dispatch(clearShoppingCartIfNecessary(uuid));
					await dispatch(createShoppingCartIfNeeded());
					// We reset the partnershop mode either way, to prevent applying different codes at once
					const codeString = new URL(location.href).searchParams.get("code");
					if (getState().sponsorCodes.excludePublicSeats || getState().sponsorCodes.partnerShopFailed
						|| getState().sponsorCodes.partnershopErrors.length > 0) {
						await dispatch(reset())
					}
					// If there is a code param, we activate the partnershop mode (again)
					if (codeString) {
						const path = location.pathname.substring(1, location.pathname.length);
						await sponsorCodeService.applyCode(theme.merchantId, theme.name, codeString, path + location.search);
					}
				},
				() => async (dispatch, getState) => {
					await dispatch(fetchEventIfNeeded(uuid));
					const event = getState().event.elements[uuid];
					dispatch(syncVolatileAvailability(event.categories));
					if (event && event.imagesMetadataIds && event.imagesMetadataIds.length > 0) {
						await dispatch(fetchMetaDataIfNeeded(event.imagesMetadataIds[0]));
					}
					const venueId = (event || {}).venueId;
					if (!venueId) return Promise.resolve();
					return dispatch(fetchVenueIfNeeded(venueId));
				},
				() => selectEvent(uuid),
			],
			clientOnly: [],
			pageTitle: 'Tickets kaufen',
		})),
	},

	{
		path: '/sp/:uuid/seatingplan',
		action: (context) => withUuid(context, 'uuid', (uuid) => ({
			component: (
				<Layout
					removePaddingTop
					hideFooterMobile
					hideBorders
					fixHeight
					hideHeader
					displayTitle
					content={<SeatingplanDisplayPage />}
				/>),
			fetchData: [
				() => async (dispatch) => {
					await dispatch(fetchBookingOfficeIfNeeded());
					await dispatch(createShoppingCartIfNeeded());
				},
				() => selectEvent(uuid),
				() => fetchSeatState(),
				() => fetchSponsorReservationsState(),
				() => async (dispatch, getState) => {
					await dispatch(fetchEventIfNeeded(uuid));
					dispatch(syncVolatileAvailability(getState().event.elements[uuid].categories));
					const seatingplanUuid = (getState().event.elements[uuid] || {}).seatingplanUuid;
					await dispatch(fetchSeatingplan(seatingplanUuid));
					await dispatch(selectSeatingplan(seatingplanUuid));
					const venueId = (getState().event.elements[uuid] || {}).venueId;
					return dispatch(fetchVenueIfNeeded(venueId));
				},
			],
			clientOnly: [
				() => async (dispatch) => {
					dispatch(loadAccessCodesConfig());
					dispatch(loadSponsorCodesConfig());
					return dispatch(updateSelectedAndSelectableSeats(uuid));
				},
			],
			pageTitle: 'Tickets kaufen - Saalplan',
		})),
	},

	{
		path: '/fs/:uuid',
		action: (context) => withUuid(context, 'uuid', (uuid) => ({
			component: (<Layout content={<EventPage />} />),
			fetchData: [
				() => async (dispatch) => {
					await dispatch(fetchBookingOfficeIfNeeded());
					await dispatch(clearShoppingCartIfNecessary(uuid));
					await dispatch(createShoppingCartIfNeeded());
				},
				() => async (dispatch, getState) => {
					await dispatch(fetchEventIfNeeded(uuid));
					const event = getState().event.elements[uuid];
					dispatch(syncVolatileAvailability(event.categories));
					if (event && event.imagesMetadataIds && event.imagesMetadataIds.length > 0) {
						await dispatch(fetchMetaDataIfNeeded(event.imagesMetadataIds[0]));
					}
					const venueId = (event || {}).venueId;
					return dispatch(fetchVenueIfNeeded(venueId));
				},
				() => selectEvent(uuid),
			],
			clientOnly: [
				() => loadAccessCodesConfig(),
				() => loadSponsorCodesConfig(),
			],
			pageTitle: 'Tickets kaufen',
		})),
	},
	{
		path: '/error',
		action: () => ({
			component: (<Layout content={<ErrorPage />} />),
			fetchData: [],
		}),
	},
    {
        path: '/partnershop-error',
        action: () => ({
            component: (<Layout content={<PartnershopErrorPage />} />),
            fetchData: [],
        }),
    },
	{
		path: '/occupied-info',
		action: () => ({
			component: (<Layout content={<WebshopOccupiedInfoPage />} />),
			fetchData: [],
		}),
	},
	{
		path: '{/*any}',
		action: () => ({
			component: (<Layout content={<NotFoundPage />} />),
			fetchData: [],
			pageTitle: 'Seite nicht gefunden',
		}),
	}
];

export default routes;
